export declare interface EbookUrl {
  label?: string;
  url?: string;
}

export enum DownloadResourceStatus {
  FREE = 'FREE',
  INSTRUCTOR = 'INSTRUCTOR',
}

export declare interface DownloadResourceConfig {
  title: string;
  status: DownloadResourceStatus.FREE | DownloadResourceStatus.INSTRUCTOR;
  url: string;
}

